module.exports = __webpack_public_path__ + "static/img/WechatIMG34@2x.a690fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/WechatIMG34@2x.png
// module id = M0SJ
// module chunks = 1